export const VERSION = '30/01/2026 [21:47]';